exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.ui-dropdown {\n    position: relative;\n}\n.ui-dropdown > * + *:last-child, .ui-dropdown .dropdown {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    min-width: 100%;\n}\n\n", ""]);
